// This file is generated by a script and should not be modified directly.
const markdown: string =
  "Latitude de la coordonnée GPS de la zone de recherche.\n\nLa recherche couvrira l’ensemble de la France si elle n’est pas spécifiée.\n\nCe champ est obligatoire lorsqu’il est utilisé avec le champ de longitude.\n"
export default markdown
